<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card
         v-if="settings != null"
    >
        <v-card-title>Auto-lead Data Format (ADF) Integration Settings</v-card-title>

        <v-card-text>

            <v-form v-model="valid" autocomplete="off">

                <v-text-field
                    label="Label"
                    v-model="settings.system_label"
                    autofocus
                    :disabled="!settings.enabled"
                    data-lpignore="true"
                />

                <v-select
                    label="CRM System"
                    :items="crm_types"
                    v-model="crm_value"
                    return-object
                    :disabled="!settings.enabled"
                />

                <v-text-field
                    label="Send To"
                    v-model="settings.send_to"
                    :disabled="!settings.enabled"
                    hint="To specify multiple email addresses, separate with a semi-colon (;)"
                    persistent-hint
                    :rules="email_validation_rules"
                    validate-on-blur
                    data-lpignore="true"
                    autocomplete="off"
                />

                <v-switch
                    v-model="settings.enabled"
                    label="Enabled"
                />

            </v-form>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!valid"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const validate = require('@/js/validate.js'); 
const { v4: uuidv4 } = require('uuid');
const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,

            settings: null,

            valid: false,

            crm_types: [
                { 'text' : 'Reynolds & Reynolds', 'value' : 'reynolds-and-reynolds' },
                { 'text' : 'Generic', 'value' : 'generic' }
            ],

            crm_value: null,
        }
    },

    methods: {

        showDialog(settings)
        {
            this.settings = _.cloneDeep(settings);

            // Set CRM value
            this.crm_value = this.crm_types.find( x => x.value == settings.system_type ) || null;

            this.dialog = true;
        },

        createNew(organization_id)
        {
            return {
                'organization_id' : organization_id,
                'integration_id' : uuidv4(),
                'system_type' : 'generic',
                'system_label' : 'CRM',
                'enabled' : true,
                'send_to' : '',
            };
        },

        onOk()
        {
            this.settings.system_type = this.crm_value.value;
            this.dialog = false;

            this.$rc.showSpinner();

            this.$rc.upsertAdfSettings(
                this.settings,

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.snackbar('ADF settings updated', 3500);
                    this.$emit('ok');
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to update ADF settings');
                }
            );
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        email_validation_rules() 
        {
            return [validate.isEmailAddresses];
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
